import { Injectable } from '@angular/core';
import * as $ from 'jquery';
import { Platform } from '@ionic/angular';
import { Network } from '@capacitor/network';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  constructor(private platform: Platform) {
    this.getDeviceSize();
    if (!this.resize_event || this.resize_event.closed) {
      this.detectResizeEvent();
    }
  }

  error_message?: string;
  device_width?: number;
  device_height?: number;
  resize_event?: any;
  is_tablet?: any;

  last_route_url?: any;

  detectResizeEvent() {
    let self = this;
    this.resize_event = this.platform.resize.subscribe(async () => {
      self.getDeviceSize();
    });
  }

  getDeviceSize() {
    let px_size = 768;
    this.device_height = window.innerHeight;
    this.device_width = window.innerWidth;

    this.is_tablet =
      this.device_width >= px_size && this.device_height >= px_size;

    //console.log('Device size: ', this.device_width, this.device_height);
  }

  getTouchPosition(e, id = 'zoomable-area') {
    let current_width = 0,
      current_height = 0,
      x = 0,
      y = 0,
      pos_x = 0,
      pos_y = 0;

    let element = document.getElementById(id);
    let page = $('ion-app').find('.ion-page').not('.ion-page-hidden');
    const style = window.getComputedStyle(element);
    const matrix = style.transform;
    const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ');
    let zoom = parseFloat(matrixValues[0]);
    let translate_x = parseFloat(matrixValues[4]);
    let translate_y = parseFloat(matrixValues[5]);

    let top_distance =
      element.getBoundingClientRect().top + $(window)['scrollTop']();
    let top_distance_content =
      page.find('#content-zoom')[0].getBoundingClientRect().top +
      $(window)['scrollTop']();
    console.log('Get Top Distance (Headersize):', top_distance_content);

    let browser_width = $('body').width();

    let container_height = page.find('#zoomable-area-container').height();
    let container_width = page.find('#zoomable-area-container').width();
    let zoomed_width = element.getBoundingClientRect().width;
    let zoomed_height = element.getBoundingClientRect().height;

    let difference = (browser_width - container_width) / 2;

    if (!this.platform.is('desktop')) {
      var touch = e.changedTouches[0];
      current_width = touch.target.clientWidth * zoom;
      current_height = touch.target.clientHeight * zoom;

      pos_x = touch.pageX;
      pos_y = touch.pageY;
    } else {
      current_width = e.target.clientWidth;
      current_height = e.target.clientHeight;
      pos_x = e.pageX;
      pos_y = e.pageY;
    }

    // console.log("Zoom: ", zoom);
    // console.log("Header Height: ", top_distance_content);
    // console.log("Top Distance Element: ", top_distance);
    // console.log("White Space Left: ", difference);
    // console.log("Translation X: ", translate_x);
    // console.log("Translation Y: ", translate_y);
    // console.log("Zoomed Height: ", zoomed_height);
    // console.log("Zoomed Width: ", zoomed_width);
    // console.log("Container Height: ", container_height);
    // console.log("Container Width: ", container_width);
    // console.log("X Before Calculation: ", pos_x);
    // console.log("Y Before Calculation: ", pos_y);

    // Calculate X and Y in PX in frame
    let x_in_frame = pos_x - difference;
    let y_in_frame = pos_y - top_distance_content;
    // console.log("X in Frame (PX): ", x_in_frame);
    // console.log("Y in Frame (PX): ", y_in_frame);

    // Calculate X and Y in PX in Content Unzoomed
    let x_in_content = x_in_frame - translate_x;
    let y_in_content = y_in_frame - translate_y;
    // console.log("X in Content (PX): ", x_in_content);
    // console.log("Y in Content (PX): ", y_in_content);

    // Calculate X and Y in PX in Content Unzoomed
    let x_in_content_zoomed = (x_in_frame - translate_x) / zoom;
    let y_in_content_zoomed = (y_in_frame - translate_y) / zoom;

    // $('#image-container').append('<div><div class="reddot" style="top:' + y_in_content_zoomed + 'px; left:' + x_in_content_zoomed + 'px;"></div></div>');

    // Calculate X and Y in PX in Content Unzoomed
    let x_in_content_percentage = (x_in_content_zoomed / container_width) * 100;
    let y_in_content_percentage =
      (y_in_content_zoomed / container_height) * 100;
    // console.log("X in Content Zoomed (%): ", x_in_content_percentage);
    // console.log("Y in Content Zoomed (%): ", y_in_content_percentage);

    // $('#image-container').append('<div><div class="reddot" style="top:' + y_in_content_percentage + '%; left:' + x_in_content_percentage + '%;"></div></div>');
    x = x_in_content_percentage;
    y = y_in_content_percentage;

    return {
      x: x,
      y: y,
    };
  }

  areEqual(a: unknown, b: unknown): boolean {
    if (Object.is(a, b)) return true;
    if (a == null || b == null) return false;

    // stack of pairs to compare
    const stack: Array<[unknown, unknown]> = [[a, b]];

    // remembers already-compared object pairs to avoid infinite loops
    const seen = new WeakMap<object, WeakMap<object, true>>();

    const markSeen = (x: object, y: object) => {
      let inner = seen.get(x);
      if (!inner) {
        inner = new WeakMap<object, true>();
        seen.set(x, inner);
      }
      inner.set(y, true);
    };

    const hasSeen = (x: object, y: object) => {
      const inner = seen.get(x);
      return inner?.has(y) === true;
    };

    while (stack.length) {
      const [x, y] = stack.pop()!;

      if (Object.is(x, y)) continue;
      if (x == null || y == null) return false;

      // Dates
      if (x instanceof Date || y instanceof Date) {
        if (!(x instanceof Date) || !(y instanceof Date)) return false;
        if (x.getTime() !== y.getTime()) return false;
        continue;
      }

      const xType = typeof x;
      const yType = typeof y;

      // primitives / functions mismatch
      if (xType !== 'object' || yType !== 'object') return false;

      const xo = x as object;
      const yo = y as object;

      // different prototypes => not equal (e.g., Map vs Object)
      if (Object.getPrototypeOf(xo) !== Object.getPrototypeOf(yo)) return false;

      // cycle check
      if (hasSeen(xo, yo)) continue;
      markSeen(xo, yo);

      // Arrays
      const xIsArr = Array.isArray(x);
      const yIsArr = Array.isArray(y);
      if (xIsArr || yIsArr) {
        if (!xIsArr || !yIsArr) return false;

        const xa = x as unknown[];
        const ya = y as unknown[];

        if (xa.length !== ya.length) return false;

        for (let i = 0; i < xa.length; i++) {
          stack.push([xa[i], ya[i]]);
        }
        continue;
      }

      // Plain objects (and other non-array objects)
      const xObj = x;
      const yObj = y;

      const xKeys = Object.keys(xObj);
      const yKeys = Object.keys(yObj);

      if (xKeys.length !== yKeys.length) return false;

      // ensure same key set
      for (const key of xKeys) {
        if (!Object.prototype.hasOwnProperty.call(yObj, key)) return false;
      }

      // compare values
      for (const key of xKeys) {
        stack.push([xObj[key], yObj[key]]);
      }
    }

    return true;
  }

  async connectedToNetwork() {
    let network = await Network.getStatus();
    return network.connected;
  }

  async getImgSrc(damage: any, network: boolean) {
    if (damage.new_photos && !Array.isArray(damage.new_photos)) {
      damage.new_photos = JSON.parse(damage.new_photos);
    }
    let path = damage?.new_photos?.length
      ? damage.new_photos[damage.new_photos.length - 1]?.path
      : network && damage?.preview_path
      ? damage.preview_path
      : !network && damage?.photos?.length
      ? damage.photos[damage.photos.length - 1]?.local_url
      : undefined;
    console.log('Path:', path, damage);
    return path;
  }
}
